































import { Vue, Component, Inject, Watch } from "vue-property-decorator";

// Types
import {
  IStoreProviderData,
  IStoreProviderMethods
} from "@/models/providers/basket/store";

@Component
export default class CategoriesList extends Vue {
  // Inject - Store Provider

  @Inject({ from: "storeProviderData" })
  public readonly $storeProviderData!: () => IStoreProviderData;

  public get $storeData() {
    return this.$storeProviderData();
  }

  @Inject({ from: "storeProviderMethods" })
  public readonly $storeProviderMethods!: IStoreProviderMethods;

  // Variables

  public searchedValue = "";

  // Methods

  public mapCategories(categories) {
    return categories.length
      ? this.$_.map(
          this.$_.orderBy(
            this.$_.filter(categories, filteredCategory => {
              return this.isFiltered(filteredCategory);
            }),
            "order"
          ),
          category => {
            return this.$_.merge(
              this.$_.pick(category, ["id", "name", "name_translated"]),
              {
                isOpen:
                  this.searchedValue.length ||
                  this.isOpen(
                    this.$storeProviderMethods.getCategory(
                      this.$storeData.rootCategories,
                      this.$_.get(category, "id")
                    )
                  ),
                isSearched: this.$_.get(category, "name_translated", "name")
                  .toLowerCase()
                  .includes(this.searchedValue.toLowerCase()),
                subcategories: this.mapCategories(
                  this.$_.get(category, "subcategories", [])
                ),
                products_count:
                  this.$_.get(category, "products_count", 0) +
                  this.$_.get(category, "sub_products_count", 0)
              }
            );
          }
        )
      : [];
  }

  public isOpen(category) {
    return (
      category.id === this.$storeData.pathCategoryId ||
      this.$_.some(this.$_.get(category, "subcategories", []), subcategory => {
        return this.isOpen(subcategory);
      })
    );
  }

  public isFiltered(category) {
    if (!this.searchedValue.length) {
      return true;
    }

    return (
      this.$_.get(category, "name_translated", "")
        .toLowerCase()
        .includes(this.searchedValue.toLowerCase()) ||
      this.$_.some(this.$_.get(category, "subcategories", []), subcategory => {
        return this.isFiltered(subcategory);
      })
    );
  }

  public switchCategory(categoryId) {
    if (
      categoryId === this.$storeData.pathCategoryId &&
      this.productsAreFiltered
    ) {
      this.$storeProviderMethods.loadCategoryProducts(
        this.$storeData.pathCategoryId,
        this.$storeData.pathCategoryId
      );
    }

    this.$storeProviderMethods.addCategoryToQuery(categoryId);
    this.searchedValue = "";
  }

  // Computed

  public get sellableCategories() {
    return this.mapCategories(this.$storeData.rootCategories);
  }

  public get productsAreFiltered() {
    return !!this.$storeData.searchValue.length;
  }

  // Watchers

  @Watch("searchedValue")
  public onSearchedValueChange() {
    this.$storeProviderMethods.filterCategories(this.searchedValue.length > 0);
  }
}
